module.exports = __webpack_public_path__ + "img/logo-no-wordmark.3d324fc8.svg";